<script>
import { VTextField } from 'vuetify/lib'
import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
export default {
    mixins: [VuelidateMixin],
    extends: VTextField,
    props: {
        filled: {
            default: true,
        },
        hideDetails: {
            default: 'auto',
        },
    },
}
</script>
